import React, { useState, useCallback } from 'react';
import t from '~t';

import { Error } from '~co/overlay/dialog';
import { Item, ItemTitle, ItemIcon, Text, Preloader } from '~ui';
import TagIcon from './icon';

export default function FiltersTagRename({
  item,
  onRename,
  onRenameCancel,
}) {
  const [name, setName] = useState(item._id);
  const [loading, setLoading] = useState(false);

  const onKeyUp = useCallback(
    (e) => {
      switch (e.keyCode) {
        case 27:
          return onRenameCancel();
      }
    },
    [onRenameCancel],
  );

  const save = useCallback(() => {
    //cancel
    if (!name.trim() || name == item._id) return onRenameCancel();

    //update collection
    setLoading(true);

    onRename(
      name,
      onRenameCancel,
      (e) => {
        Error(e);
        onRenameCancel();
      },
    );
  }, [name, item._id, onRename, onRenameCancel]);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      save();
    },
    [save],
  );

  return (
    <form onSubmit={onSubmit}>
      <Item>
        {loading ? (
          <ItemIcon>
            <Preloader />
          </ItemIcon>
        ) : (
          <TagIcon />
        )}

        <ItemTitle>
          <Text
            type='text'
            variant='less'
            required
            autoFocus
            selectAll
            disabled={loading}
            value={name}
            placeholder={t.s('enterTitle')}
            onKeyUp={onKeyUp}
            onChange={(e) => setName(e.target.value)}
            onBlur={save}
          />
        </ItemTitle>
      </Item>
    </form>
  );
}
